class AlertNotification {
  constructor() {
    this.notification = document.querySelector('.alert-notification');
    this.delayTime = 3500;
    this.timerId = null;
    this.isActive = false;
  }

  showMessage(message, type) {
    this.clearNotification();
    this.notification.innerHTML = message.replace(/\n/g, '<br>');
    this.notification.classList.add('active', type);
    this.isActive = true;

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    if (this.isActive && type === 'error') {
      this.notification.classList.add('shake');

      setTimeout(() => {
        this.notification.classList.remove('shake');
      }, 500);
    }

    this.timerId = setTimeout(() => {
      this.notification.classList.remove('active', type);

      this.isActive = false;
    }, this.delayTime);
  }

  success(message) {
    this.showMessage(message, 'success');
  }

  error(message) {
    this.showMessage(message, 'error');
  }

  warning(message) {
    this.showMessage(message, 'warning');
  }

  info(message) {
    this.showMessage(message, 'information');
  }

  clearNotification() {
    this.notification.textContent = '';
    this.notification.classList.remove('active', 'success', 'error', 'warning', 'information');
  }
}

window.alertNotification = new AlertNotification();
